var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 7.3335V11.3335C14.6667 14.0002 14 14.6668 11.3334 14.6668H4.66671C2.00004 14.6668 1.33337 14.0002 1.33337 11.3335V4.66683C1.33337 2.00016 2.00004 1.3335 4.66671 1.3335H5.66671C6.66671 1.3335 6.88671 1.62683 7.26671 2.1335L8.26671 3.46683C8.52004 3.80016 8.66671 4.00016 9.33337 4.00016H11.3334C14 4.00016 14.6667 4.66683 14.6667 7.3335Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 1.3335H11.3334C12.6667 1.3335 13.3334 2.00016 13.3334 3.3335V4.2535",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.f29f479330e100d4d7fb2e0ea6f2a057.svg";
export { ForwardRef as ReactComponent };